import React, { useState, useEffect } from "react";
import { FormGroup, FormSelect, Row, Col } from "shards-react";
import baseUrl from "config/baseUrl";
import ReactPaginate from "react-paginate";
import dayjs from "dayjs";
import useToken from "shared/hook/useToken";
import { SelectIndicatorsDataset, SelectAgency } from "shared/components";

const axios = require("axios").default;

const PowerbiList = (props) => {
  const { token } = useToken();
  const [agencyId, setAgencyId] = useState(null);
  const [dataindicatorsDataset, setDataindicatorsDataset] = useState(null);
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const formatDate = (date) => {
    const split = date
      .replace("T", " ")
      .replace(".000Z", "")
      .split(" ");
    return `${dayjs(split[0]).format("DD/MM/YYYY")} ${split[1]}`;
  };

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          indicatorsAgencySettingId: agencyId,
          id: indicatorsDatasetId
        },
        show: 30,
        page: pageNumber,
        orderBy: "id",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/indicatorsDataset`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataindicatorsDataset(response.data);
          setTotalPage(response.data.totalPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [pageNumber, indicatorsDatasetId, agencyId]);

  const nextPage = (page, total_page) => {
    setPageNumber(page + 1);
    setTotalPage(total_page);
  };
  return (
    <>
      <Row>
        <Col md="12">
          <h6 style={{ marginBottom: "30px" }}>
            จัดการคำอธิบายของข้อมูล/ตัวชี้วัด
          </h6>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormGroup>
            <label>หน่วยงานเจ้าของข้อมูล</label>
            <SelectAgency
              placeholder="เลือก"
              name="agencyId"
              onChange={(e) => {
                if (e.target.value === "0") {
                  setAgencyId("");
                } else {
                  setAgencyId(e.target.value);
                }
              }}
              defaultValue={agencyId}
              value={agencyId}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>ข้อมูล/ตัวชี้วัด</label>
            <SelectIndicatorsDataset
              placeholder="เลือก"
              name="indicatorsDatasetId"
              onChange={(e) => {
                setIndicatorsDatasetId(
                  e.target.value === "0" ? null : e.target.value
                );
              }}
              agencySettingId={agencyId}
              defaultValue={indicatorsDatasetId}
              value={indicatorsDatasetId}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <div className="table-responsive">
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th className="mw200" scope="col">
                    รายการข้อมูล/ตัวชี้วัด
                  </th>
                  <th className="mw200" scope="col">
                    ผู้อัพเดทข้อมูลล่าสุด
                  </th>
                  <th className="mw160" scope="col">
                    วันที่อัพเดทข้อมูล
                  </th>
                  <th className="mw100" scope="col">
                    เครื่องมือ
                  </th>
                </tr>
              </thead>
              <tbody className="table-middle">
                {dataindicatorsDataset != null &&
                dataindicatorsDataset.data.length > 0 ? (
                  dataindicatorsDataset.data.map((item, key) => (
                    <tr key={key}>
                      <td>
                        {item.id} : {item.indicatorsDatasetSettingName}
                      </td>
                      <td>
                        <div className="bole">
                          {item.firstName} {item.lastName}
                        </div>
                        <div className="text-black-50">{item.agencyName}</div>
                      </td>
                      <td>{formatDate(item.lastUpdate)}</td>
                      <td>
                        <a
                          className="btn-link"
                          href={`/administrator/powerbi/detail/${item.id}`}
                          role="button"
                        >
                          แก้ไข
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5}>ยังไม่มีรายการข้อมูล/ตัวชี้วัด</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Col>
        <Col md="12" style={{ textAlign: "right" }}>
          {dataindicatorsDataset != null && (
            <ReactPaginate
              pageCount={totalPage}
              forcePage={pageNumber - 1}
              containerClassName="pagination"
              nextLabel=">"
              previousLabel="<"
              onPageChange={({ selected }) => {
                nextPage(selected, totalPage);
              }}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default PowerbiList;
